import FlagInappropriate from './FlagInappropriate'

export default FlagInappropriate



// WEBPACK FOOTER //
// ./src/containers/FlagInappropriate/FlagInappropriate/index.js